import styled from 'styled-components';

const Wrapper = styled.main`
  .product-center {
    display: grid;
    gap: 6rem;
    margin-top: 2rem;
  }
  .price {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .desc {
    line-height: 2;
    max-width: 45em;
  }
  .info {
    text-transform: capitalize;
    width: 300px;
    display: grid;
    grid-template-columns: 125px 1fr;
    span {
      font-weight: 700;
    }
    margin-bottom: 10px;
  }
  .reviews-loading {
    color: var(--clr-grey-5);
  }
  @media (min-width: 992px) {
    .product-center {
      grid-template-columns: 1fr 1fr;
    }
    .price {
      font-size: 1.25rem;
    }
    .product-center {
      gap: 14rem;
    }
  }

  .ReviewHeading{
    font-size : 20px;
    margin-bottom: 20px;
    font-weight: bold;
  }

  @media (max-width: 630px) {
    .content{
      min-width: 100px !important;
    }
  }

  @media (max-width: 1190px) and (min-width: 990px) {
    .content {
        min-width: 100px !important;
    }
}
`;



export default Wrapper;
